import { render, staticRenderFns } from "./FormMoral.vue?vue&type=template&id=19a10957"
import script from "./FormMoral.vue?vue&type=script&lang=js"
export * from "./FormMoral.vue?vue&type=script&lang=js"
import style0 from "./FormMoral.vue?vue&type=style&index=0&id=19a10957&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19a10957')) {
      api.createRecord('19a10957', component.options)
    } else {
      api.reload('19a10957', component.options)
    }
    module.hot.accept("./FormMoral.vue?vue&type=template&id=19a10957", function () {
      api.rerender('19a10957', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/comparecientes/FormMoral.vue"
export default component.exports